<template>
  <div>
    <UserCard @create-cust="createCustVisible = true">
      <div
        class="d-flex justify-content-between align-items-center"
        style="min-height: max-content"
      >
        <div class="switch-tabs_wrappers flex-grow-1 mt-1 pr-2">
          <div class="switch-tabs">
            <div
              v-for="item in switchCustMode"
              :key="item.value"
              class="switch-tabs_items"
              :class="{ active: item.value === custMode }"
              @click="custModeChange(item)"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <pagination
            size="mini"
            style="min-width: max-content"
            :current-page="page.curPage"
            :page-size="page.pageSize"
            :page-total="page.pageTotal"
            :layouts="['Total', 'Sizes', 'PrevPage', 'NextPage']"
            :pageSizes="[15, 20, 50]"
            @change="changePage"
          />
          <div class="ml-3 d-flex align-items-center">
            <vxe-button size="mini" circle @click="reload()">
              <i class="vxe-button--icon vxe-icon--refresh" />
            </vxe-button>
            <vxe-button
              size="mini"
              class="ml-3"
              circle
              @click="searchVisible = true"
            >
              <i class="vxe-button--icon vxe-icon--search" />
            </vxe-button>
          </div>
        </div>
      </div>
    </UserCard>
    <div
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      style="overflow-x: hidden"
    >
      <CustCard :data="data" @reload="reload()" />
    </div>
    <CreateCust :visible.sync="createCustVisible" @reload="reload()" />
    <Search ref="search" :visible.sync="searchVisible" @query="getData" />
  </div>
</template>

<script>
import UserCard from './user-card.vue'
import CustCard from './cust-card.vue'
import CreateCust from '../create'
import Search from './search.vue'
const initPage = { curPage: 1, pageSize: 15, pageTotal: 0 }
export default {
  components: { UserCard, CustCard, CreateCust, Search },
  mixins: [],
  props: {},
  data() {
    return {
      custMode: '',
      createCustVisible: false,
      loading: false,
      data: [],
      page: { ...initPage },
      searchVisible: false,
    }
  },
  computed: {
    switchCustMode() {
      return [
        { label: this.$l('tabs_items_all') || '所有客户', value: '' },
        { label: this.$l('tabs_items_reserve') || '海选客户', value: 'A' },
        { label: this.$l('tabs_items_potential') || '潜在客户', value: 'B' },
        { label: this.$l('tabs_items_partners') || '正式客户', value: 'C' },
      ]
    },
  },
  methods: {
    custModeChange({ value }) {
      this.custMode = value
      this.resetPage()
      this.$refs.search.reset()
      this.$refs.search.query()
    },
    changePage(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$refs.search.query()
    },
    resetPage() {
      this.page = { ...initPage }
    },
    reload() {
      this.$refs.search.query()
    },
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .masterCustomerListByUserApi({
          ...this.page,
          custMode: this.custMode,
          ...form,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.data = res.body.data
      this.page.pageTotal = res.body.count
      this.page.pageSize = res.body.pageSize
      this.page.curPage = res.body.curPage
    },
  },
}
</script>

<style lang="scss" scoped>
.switch-tabs_wrappers .switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding-top: 16px;
    padding-bottom: 15px;
    padding-left: 2px;
    padding-right: 2px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 26px;
    cursor: pointer;
    min-width: max-content;
    border-bottom: 3px solid transparent;
  }
  .switch-tabs_items.active {
    color: #007bff;
    border-color: #1989fa;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}
</style>
